import Container from '@grnhse/seedling/lib/birch/components/container';
import styled from 'styled-components';

const BorderlessContainer = styled(Container)`
  border: none;
`;

export default BorderlessContainer;
